import { Button, Form } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import useAxios from "../../../../Utils/useAxios";
import { InputField, SelectionField } from "../../../../CommonElements";
import createTipeAbsensi from "../services/createTipeAbsensi";
import updateTipeAbsensi from "../services/updateTipeAbsensi";

const TipeAbsensiForm = ({ resetState, toggle, data }) => {
  const { control, handleSubmit } = useForm({ defaultValues: data });
  const axiosInstance = useAxios();

  const createUserRole = (data) => {
    createTipeAbsensi(axiosInstance, data).then(() => {
      resetState();
      toggle();
    });
  };

  const editUserRole = (data) => {
    updateTipeAbsensi(axiosInstance, data.id_tipe_absensi, data).then(() => {
      resetState();
      toggle();
    });
  };

  return (
    <Form
      onSubmit={
        data ? handleSubmit(editUserRole) : handleSubmit(createUserRole)
      }
    >
      <Controller
        name="nama_tipe_absensi"
        control={control}
        rules={{
          required: "Harap masukkan nama tipe absensi",
        }}
        render={({ field, fieldState }) => (
          <InputField
            label={"Nama Tipe Absensi"}
            defaultValue={data?.nama_tipe_absensi}
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="mengurangi_jatah_cuti"
        control={control}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Mengurangi Jatah Cuti"}
            defaultValue={data?.mengurangi_jatah_cuti ?? "Y"}
            options={[
              { id: "Y", name: "Ya" },
              { id: "N", name: "Tidak" },
            ]}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Controller
        name="perlu_persetujuan"
        control={control}
        render={({ field, fieldState }) => (
          <SelectionField
            label={"Perlu Persetujuan"}
            defaultValue={data?.perlu_persetujuan ?? "Y"}
            options={[
              { id: "Y", name: "Ya" },
              { id: "N", name: "Tidak" },
            ]}
            fieldState={fieldState}
            {...field}
          />
        )}
      />
      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default TipeAbsensiForm;
